<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import AppTooltip from '@shared/components/ui/AppTooltip.vue'

withDefaults(
  defineProps<{
    connected?: boolean
    size?: string
  }>(),
  {
    size: '40',
  }
)

const { t } = useI18n()

const reload = () => {
  document.location.reload()
}
</script>

<template>
  <AppTooltip
    v-if="!connected"
    :content="t('chat.labels.socketDisconnectedReload')"
    placement="bottom"
  >
    <AppButton circle text only-icon @click="reload">
      <AppIcon shape="refresh" color="error" :size="size" />
    </AppButton>
  </AppTooltip>
</template>
